<template>
  <div v-html="template">
    <!-- <div>
    <pre>{{ transaction }}</pre> -->
  </div>
</template>

<script>
import filters from "@/filters";
import { translate_status, translate_type } from "../local_translator";

filters.translate_status = translate_status;
filters.translate_type = translate_type;

export default {
  name: "FelGTTransactionModalBilling",
  filters: filters,
  components: {},
  computed: {
    template() {
      let vm = this;
      if (vm.transaction.felgt_emitter) {
        let tpl = vm.transaction.felgt_emitter.template;
        if (tpl.html) return tpl.html;
        else return "X";
      }
      return "?";
    },
  },
  props: { transaction: Object },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
